import { CareerProfessionsQuery } from 'core';

export interface IProfessionSkill {
  id: string;
  name: string;
  slug: string;
  category: string;
  iconUrl: string | null;
  /** Навык уже есть у студента — красим и считаем в «X из Y». */
  have: boolean;
}

export interface IProfessionCourse {
  courseId: string;
  courseName: string;
  /** Страница курса на сайте школы: витрины курсов в ЛМС нет. */
  courseUrl: string;
  completed: boolean;
}

export interface IProfession {
  code: string;
  title: string;
  summary: string;
  about: string;
  /** Знак профессии из справочника; пустой рисуется портфелем. */
  icon: string;
  /** Вилка целиком нуллабельна: незаполненную не показываем вовсе. */
  salaryFrom: number | null;
  salaryTo: number | null;
  salaryCurrency: string;
  haveCount: number;
  totalCount: number;
  /** Вакансий В НАШЕЙ ЛЕНТЕ, не на рынке — экран обязан это подписать. */
  liveVacancies: number;
  skills: IProfessionSkill[];
  courses: IProfessionCourse[];
}

export const transformProfessions = (data: CareerProfessionsQuery | undefined): IProfession[] =>
  (data?.careerProfessions ?? []).map((row) => ({
    code: row.code,
    title: row.title,
    summary: row.summary,
    about: row.about,
    icon: row.icon,
    salaryFrom: row.salaryFrom ?? null,
    salaryTo: row.salaryTo ?? null,
    salaryCurrency: row.salaryCurrency,
    haveCount: row.haveCount,
    totalCount: row.totalCount,
    liveVacancies: row.liveVacancies,
    skills: row.skills.map((skill) => ({
      id: skill.id,
      name: skill.name,
      slug: skill.slug,
      category: skill.category,
      iconUrl: skill.iconUrl ?? null,
      have: skill.have,
    })),
    courses: row.courses.map((course) => ({
      courseId: course.courseId,
      courseName: course.courseName,
      courseUrl: course.courseUrl,
      completed: course.completed,
    })),
  }));
